 <p *ngIf="countdown$ | async as countdown" style="padding: 0 16px "> Przerwa techniczna za {{ countdown }}</p>
